/*
  normalizeAnswer
  - Produces the same storage shape v1 expects per input type
  - selectOne → string or object { value, otherValue? }
  - selectMultiple → array of strings or array of { value, otherValue? }
  - primitives (text/date/number) → pass-through
  Note: otherValue augmentation happens in save layer where we have access
  to companion _other_ fields; here we assume caller passes final structured value.
*/

export default function normalizeAnswer(inputType, value) {
  if (value === undefined) return undefined;
  if (value === null) return null;

  if (inputType === 'selectOne') {
    // Accept raw string or { value, otherValue }
    if (typeof value === 'object' && value !== null && 'value' in value) return value;
    return value;
  }

  if (inputType === 'selectMultiple') {
    if (!Array.isArray(value)) return value ? [value] : [];
    return value;
  }

  // freeText, freeTextArea, freeTextNumerical, date, etc.
  return value;
}


